module.exports = __webpack_public_path__ + "928df03183bea9106b37527887c17e18.png";